export default "__VITE_ASSET__B0o$EofO__"